/*
**************************************************************************
Title:          Tree Component
Created By:     Anshul Paliwal
Created on:     30/01/2021
Description:    Tree Component - Tree Component for location heirarchy
**************************************************************************
*/
import { Component, Input, Output, EventEmitter, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { TreeNode } from './tree.item';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TreeComponent implements AfterViewChecked {
  @Input() searchTxt;
  @Input() treeData: TreeNode[];
  @Input() isActive: boolean;
  @Input() currentDepth = 0;
  @Input() selectedIndex = 0;
  @Input() nodeDepth = 0;

  @Output() selectedTreeItem = new EventEmitter();
  @Output() selected = new EventEmitter();

  control = false;
  refreshElementFocus = false;

  ngAfterViewChecked() {
    if (!this.refreshElementFocus) {
      return;
    }
    try {
      const focusable = document.querySelectorAll('.focus');
      const element: HTMLInputElement = focusable[0] as HTMLInputElement;
      element.focus();
      this.refreshElementFocus = false;
    } catch {
    }
  }

  focusIn(event, node, index) {
    this.selectedIndex = index;
    this.currentDepth = this.nodeDepth;
  }

  focusOut() {
    this.selectedIndex = -1;
    this.currentDepth = -1;
  }

  onSelectedItemClick(node) {
    event.preventDefault();
    this.selectedTreeItem.emit(node);
    this._selected(node);
    this.control = true;
  }

  toggleChild(node) {
    node.showChildren = !node.showChildren;
  }

  _selected(node) {
    this.selected.emit(node);
  }

  setRow(index: number) {
    this.selectedIndex = index;
    this.refreshElementFocus = true;
  }

  setDepth(index: number) {
    this.currentDepth = index;
    this.refreshElementFocus = true;
  }

  arrowPress(event, node) {
    switch (event.key) {
      case 'Enter':
          this.toggleChild(node);
        break;
    }
  }

  labelPress(event, node) {
    switch (event.key) {
      case 'Enter':
        this.onSelectedItemClick(node);
        break;
   /* case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        if (this.selectedIndex == 0) {
          this.refocusParent.emit();
          if (this.currentDepth != 0) {
            this.setDepth(--this.currentDepth);
          }
        } else {
          this.setRow(--this.selectedIndex);
        }
        break;
      case 'ArrowDown':
        event.preventDefault();
        if (node.children && node.showChildren) {
          this.setDepth(++this.currentDepth);
        } else {
          if (this.selectedIndex < this.treeData.length - 1) {
            this.setRow(++this.selectedIndex);
          }
        }
        break;
      case 'ArrowRight':
        console.log('right')
         if (this.selectedIndex == this.treeData.length - 1) {
        node.showChildren = true;
        if (node.showChildren) {
          event.preventDefault();
          this.setDepth(++this.currentDepth);
         }
        } else {
          event.preventDefault();
          this.setRow(++this.selectedIndex);
        }
        break;*/
    }
  }

}
